import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faArrowDown, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './MovimientosData.css';
import baseURL from '../../url';
import * as XLSX from 'xlsx';

export default function MovimientosData() {
    const [movimientos, setMovimientos] = useState([]);
    const [articulos, setArticulos] = useState([]);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [tipoMovimiento, setTipoMovimiento] = useState('');
    const [idArticulo, setIdArticulo] = useState('');
    const [usuario, setUsuario] = useState({});

    useEffect(() => {
        const cachedUser = sessionStorage.getItem('usuario');
        if (cachedUser) {
            try {
                setUsuario(JSON.parse(cachedUser));
            } catch (e) {
                console.error('Error parsing cached user:', e);
            }
        }
    }, []);

    const canDeleteMovimientos = () => {
        if (!usuario || !usuario.rol) return false;
        if (usuario.rol === 'admin') return true;
        if (usuario.rol === 'empleado') {
            let permisos = usuario.permisos;
            if (typeof permisos === 'string') {
                try {
                    permisos = JSON.parse(permisos);
                } catch (e) {
                    permisos = {};
                }
            }
            if (!permisos) return false;
            const modPerm = permisos['inventarios'];
            if (modPerm) {
                return !!modPerm['editar'];
            }
        }
        return false;
    };

    const eliminarMovimiento = (idMovimiento) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Esta acción eliminará el registro del movimiento!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioMovimientosDelete.php?idMovimiento=${idMovimiento}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarMovimientos();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    useEffect(() => {
        cargarMovimientos();
        cargarArticulos();
    }, []);

    const cargarArticulos = () => {
        fetch(`${baseURL}/inventarioArticulosGet.php`)
            .then(response => response.json())
            .then(data => setArticulos(data.articulos || []))
            .catch(error => console.error('Error:', error));
    };

    const cargarMovimientos = () => {
        let url = `${baseURL}/inventarioMovimientosGet.php?`;
        const params = [];

        if (fechaInicio) params.push(`fechaInicio=${fechaInicio}`);
        if (fechaFin) params.push(`fechaFin=${fechaFin}`);
        if (tipoMovimiento) params.push(`tipoMovimiento=${tipoMovimiento}`);
        if (idArticulo) params.push(`idArticulo=${idArticulo}`);

        url += params.join('&');

        fetch(url)
            .then(response => response.json())
            .then(data => setMovimientos(data.movimientos || []))
            .catch(error => console.error('Error:', error));
    };

    const limpiarFiltros = () => {
        setFechaInicio('');
        setFechaFin('');
        setTipoMovimiento('');
        setIdArticulo('');
    };

    const descargarExcel = () => {
        const data = movimientos.map(item => ({
            Fecha: new Date(item.fecha).toLocaleString(),
            Artículo: item.nombreArticulo,
            Código: item.codigoArticulo,
            Movimiento: item.tipoMovimiento.toUpperCase(),
            Cantidad: item.cantidad,
            Unidad: item.simboloUnidad,
            Motivo: item.motivo,
            Referencia: item.referencia
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');
        XLSX.writeFile(wb, 'movimientos_inventario.xlsx');
    };

    useEffect(() => {
        cargarMovimientos();
    }, [fechaInicio, fechaFin, tipoMovimiento, idArticulo]);

    return (
        <div>

            <div className='deFlexContent' style={{ display: 'flex' }}>
                <div className='deFlex2'>
                    <button className='excel' onClick={descargarExcel}>
                        <FontAwesomeIcon icon={faArrowDown} /> Excel
                    </button>
                    <button className='pdf' onClick={limpiarFiltros}>
                        Limpiar Filtros
                    </button>
                </div>

                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <label>Fecha Inicio</label>
                        <input
                            type="date"
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                        />
                    </div>
                    <div className='inputsColumn'>
                        <label>Fecha Fin</label>
                        <input
                            type="date"
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />
                    </div>
                    <div className='inputsColumn'>
                        <label>Tipo</label>
                        <select value={tipoMovimiento} onChange={(e) => setTipoMovimiento(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="entrada">Entrada</option>
                            <option value="salida">Salida</option>
                        </select>
                    </div>
                    <div className='inputsColumn'>
                        <label>Artículo</label>
                        <select value={idArticulo} onChange={(e) => setIdArticulo(e.target.value)}>
                            <option value="">Todos</option>
                            {articulos.map(art => (
                                <option key={art.idArticulo} value={art.idArticulo}>
                                    {art.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                    
                </div>
            </div>

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Artículo</th>
                            <th>Movimiento</th>
                            <th>Cantidad</th>
                            <th>Unidad</th>
                            <th>Motivo</th>
                            <th>Referencia</th>
                            {canDeleteMovimientos() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {movimientos.map((item, index) => (
                            <tr key={index}>
                                <td>{new Date(item.fecha).toLocaleString()}</td>
                                <td>
                                    {item.nombreArticulo}
                                    {item.codigoArticulo && <span style={{ color: '#888' }}> ({item.codigoArticulo})</span>}
                                </td>
                                <td>
                                    <span className={`badge ${item.tipoMovimiento}`}>
                                        {item.tipoMovimiento.toUpperCase()}
                                    </span>
                                </td>
                                <td>{item.cantidad}</td>
                                <td>{item.simboloUnidad}</td>
                                <td>{item.motivo || '-'}</td>
                                <td>{item.referencia || '-'}</td>
                                {canDeleteMovimientos() && (
                                    <td>
                                        <button 
                                            className="btnDelete" 
                                            onClick={() => eliminarMovimiento(item.idMovimiento)}
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                color: '#d33',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                padding: '5px'
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}





